import { busService } from "../../bus";
import { RemoveSubModelMessage, RoomChangedMessage } from "flavr-common";
import { xrService } from "../../xr/XRService";
import { resolveUid } from "../model/Utils";
const connection = busService.connection("ScriptXR");
const presentingChangedSubscriptions = new Map();
connection.subscribeByType(RemoveSubModelMessage, (msg) => {
    presentingChangedSubscriptions.delete(msg.uid);
});
connection.subscribeByType(RoomChangedMessage, () => {
    presentingChangedSubscriptions.clear();
});
export class ScriptXR {
    static subscribePresentingChanged(uid, callback) {
        try {
            uid = resolveUid(uid);
            let subscriptions = presentingChangedSubscriptions.get(uid);
            if (!subscriptions) {
                subscriptions = new Set();
                presentingChangedSubscriptions.set(uid, subscriptions);
            }
            subscriptions.add(callback);
            return true;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    static unsubscribePresentingChanged(uid, callback) {
        uid = resolveUid(uid);
        const subscriptions = presentingChangedSubscriptions.get(uid);
        if (!subscriptions)
            return;
        subscriptions.delete(callback);
    }
    static isPresenting() {
        return xrService.isPresenting();
    }
}
